import React, { useState } from 'react'
import { useAppDispatch } from '../../../../../store/store'
import { setFormTranslatedText } from 'pages/auth/utils/setFormTranslatedText'
import { useTranslation } from 'react-i18next'
import { updateUserPersonalDetails } from 'store/reducers/userReducer'
import { Button } from 'shared/components/button/Button'
import Checkbox from '../../../../../shared/components/checkbox/Checkbox'
import { useUpdateSfUserMutation } from 'store/api-slices/userSlice'

export const MarketingMessage: React.FC = () => {
  const dispatch = useAppDispatch()

  const { t } = useTranslation('', {
    keyPrefix: `pages.marketingMessagePage`,
  })
  setFormTranslatedText('marketingMessagePage')
  const [userNewsletterData, setuserNewsletterData] = useState(false)
  const [updateSfUser] = useUpdateSfUserMutation()
  const handleFieldChange = async () => {
    setuserNewsletterData(!userNewsletterData)
  }

  const handelContinueButtonClicked = async () => {
    try {
      await updateSfUser({
        seenMarketingMessage: true,
        newsletter: userNewsletterData,
      }).unwrap()
      dispatch(updateUserPersonalDetails({ seenMarketingMessage: true }))
    } catch (err) {
      console.log({ err })
    }
  }

  return (
    <>
      <Checkbox
        callback={() => handleFieldChange()}
        id={'newsletter'}
        label={t('newsletterCheckboxText')}
        checked={userNewsletterData}
      ></Checkbox>
      <Button
        type="submit"
        text={t('buttonsText')}
        callback={() => handelContinueButtonClicked()}
      />
    </>
  )
}
